<div class="metadata-panel">
  <div class="metadata-panel-header">
    <h2>Détails</h2>
    <button class="close-button" (click)="close()">
      <img src="assets/icons/close-icon.svg" alt="Fermer" />
    </button>
  </div>

  <div *ngIf="!loadingMetadata" class="metadata-panel-content">
    <div
      class="metadata-panel-content-row"
      [class.is-array]="isArray(item.value)"
      *ngFor="let item of metadata"
    >
      <div class="metadata-panel-content-row-key">
        <strong>{{ item.key }}</strong>
        <img
          *ngIf="isArray(item.value)"
          src="assets/icons/right-chevron.svg"
          alt="Déplier"
          [ngClass]="{ rotated: dropdownIsActive }"
          (click)="toggleChevron()"
        />
      </div>

      <div
        class="metadata-panel-content-row-value"
        [ngClass]="{ active: dropdownIsActive }"
      >
        <ng-container *ngIf="!isArray(item.value)">
          {{ item.value }}
        </ng-container>

        <ng-container *ngIf="isArray(item.value) && dropdownIsActive">
          <div
            *ngFor="let child of item.value"
            class="metadata-panel-content-row-value-child"
          >
            <span class="metadata-panel-content-row-value-child-key"
              >{{ child.key }}:</span
            >
            <span class="metadata-panel-content-row-value-child-value">{{
              child.value
            }}</span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div *ngIf="loadingMetadata" class="metadata-panel-loading-container">
    <lib-little-bars-loader></lib-little-bars-loader>
  </div>
</div>
